<template>
  <div class="cadfm-container-horizontal">
    <!-- <Left  v-show="isVisibleLeft&&!isPlugin" :lang="lang.Left"></Left> -->
    <!-- <Left  v-show="isVisibleLeft" :lang="lang.Left"></Left> -->
    <Middle :lang="lang.Middle"></Middle>
    <Right v-show="isVisibleRight" :lang="lang.Right"></Right>
 </div>
</template>

<script>
// import Left from '@/components/RequestManager/Views/RequestTable/Left/Left'
import Middle from '@/components/RequestManager/Views/RequestTable/Middle/Middle'
import Right from '@/components/RequestManager/Views/RequestTable/Right/Right'
import { mapGetters } from 'vuex'

export default {
  name: 'RequestTable',
  components:{
    // Left,
    Middle,
    Right
  },
  props:{
    lang: Object
  },
  computed:{
    ...mapGetters([
        'isPlugin',
       
      ]),
  },
  data () {
    return {
      isVisibleRight: true,
      isVisibleLeft: true
    }
  },
  mounted () {
    
  },
  methods: {
    
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/RequestManager/Views/RequestTable.vue